import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Autocomplete from '../Autocomplete';
import sortArrayByProperty from '@afosto/utils/array/sortArrayByProperty';
import { oauth as oauthApi } from '@afosto/iam/api/Oauth';

const ClientSearch = ({ scopes, ...props }) => {
  const [clientSuggestions, setClientSuggestions] = useState([]);
  const [isFetchingClients, setIsFetchingClients] = useState(true);
  const scopesString = scopes.join(';');

  useEffect(() => {
    let isMounted = true;

    const fetchAllClients = async () => {
      setIsFetchingClients(true);

      try {
        const response = await oauthApi.listClients(
          {
            scope: scopesString,
          },
          {
            headers: {
              'x-page-size': 100,
            },
          },
        );
        const { data: clients = [] } = response;

        if (isMounted) {
          const suggestions = clients.map(client => ({
            ...client,
            label: client.name,
            value: client.id,
          }));
          setClientSuggestions(sortArrayByProperty(suggestions, 'label'));
        }
      } catch (err) {
        if (isMounted) {
          setClientSuggestions([]);
        }
      } finally {
        if (isMounted) {
          setIsFetchingClients(false);
        }
      }
    };

    fetchAllClients();

    return () => {
      isMounted = false;
    };
  }, [scopesString]);

  return (
    <Autocomplete
      {...props}
      options={clientSuggestions}
      loading={isFetchingClients}
      autocomplete="off"
    />
  );
};

ClientSearch.propTypes = {
  ...Autocomplete.propTypes,
  scopes: PropTypes.array,
};

ClientSearch.defaultProps = {
  ...Autocomplete.defaultProps,
  scopes: [],
};

export default ClientSearch;
